import { ControlPanelService } from 'src/states/control-panel.service';
import { Component, OnInit, Input } from '@angular/core';
import { ScreenService } from 'src/core/services/screen.service';
import { Router, NavigationEnd } from '@angular/router';
import { ControlPanel } from 'src/states/control-panel.actions';
import { Store } from '@ngxs/store';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  menuItems = [];
  selectedRoute = '';

  menuOpened: boolean;
  temporaryMenuOpened = false;

  @Input()
  title: string;

  menuMode = 'shrink';
  menuRevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;

  Version = null;

  constructor(
    private screen: ScreenService,
    private router: Router,
    private store: Store,
    private panelLayoutService: PanelLayoutService,
    private controlPanelService: ControlPanelService) {

      this.panelLayoutService.GetVersion().then(res => {
        this.Version = res;
      });

      this.controlPanelService.navigationItems$.subscribe( i => {
        if (!i) {
          this.store.dispatch(new ControlPanel.GetNavigationMenu());
        } else {
          this.menuItems = i;
        }
      });

      this.controlPanelService.changeMenuIsOpen.subscribe( o => {

        this.menuOpened = o;
        this.temporaryMenuOpened = false;
      });
     }

  ngOnInit() {
    // this.menuOpened = this.screen.sizes['screen-large'];

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split('?')[0];
      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();
  }

  toggleMenu() {
    this.controlPanelService.changeMenuIsOpen.next(!this.menuOpened);
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];

    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = isXSmall ? 0 : 50;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event) {
    const path = event.itemData.DefaultRoute != null ? event.itemData.DefaultRoute : event.itemData.Route;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      /*if (event.node.selected) {
        pointerEvent.preventDefault();
      } else {*/
        this.router.navigate([path]);
      //}

      //if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.controlPanelService.changeMenuIsOpen.next(false);
        pointerEvent.stopPropagation();
      //}
    } else {
      pointerEvent.preventDefault();
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
      this.controlPanelService.changeMenuIsOpen.next(true);
    }
  }

}
